export const PERMISSIONS = {
  EXPORT_SENDER_ADDRESS: "EXPORT_SENDER_ADDRESS",
  EXPORT_RECEIVER_ADDRESS: "EXPORT_RECEIVER_ADDRESS",
  EXPORT_RIDER_INFO: "EXPORT_RIDER_INFO",
  EXPORT_DAILY_LOGIN_USER_REPORT: "EXPORT_DAILY_LOGIN_USER_REPORT",
  VIEW_EXPORT_PAGE: "VIEW_EXPORT_PAGE",
  VIEW_DANGER_USERS: "VIEW_DANGER_USERS",
  EXPORT_DANGER_USER_LIST: "EXPORTT_DANGER_USER_LIST",
  VIEW_ORDER_PAGE: "VIEW_ORDER_PAGE",
  BULK_SEARCH_ORDER: "BULK_SEARCH_ORDER",
  EXPORT_ORDER_LIST: "EXPORT_ORDER_LIST",
  EXPORT_TRANSACTION_LIST: "EXPORT_TRANSACTION_LIST",
  EXPORT_TOPUP_LIST: "EXPORT_TOPUP_LIST",
  VIEW_COD_RECONCILATION_CALENDER: "VIEW_COD_RECONCILATION_CALENDER",
  EXPORT_COD_RECONCILATION_REPORT: "EXPORT_COD_RECONCILATION_REPORT",
  EXPORT_DISCOUNT_CODE_LIST: "EXPORT_DISCOUNT_CODE_LIST",
  UPDATE_VOUCHER_SETTINGS: "UPDATE_VOUCHER_SETTINGS",
  CREATE_BANNER: "CREATE_BANNER",
  UPDATE_BANNER: "UPDATE_BANNER",
  EXPORT_PROFIT_REPORT: "EXPORT_PROFIT_REPORT",
  EXPORT_MTU_REPORT: "EXPORT_MTU_REPORT",
  EXPORT_VOUCHER_REDEMPTION_LIST: "EXPORT_VOUCHER_REDEMPTION_LIST",
  CAMPAIGN_PAGE: "CAMPAIGN_PAGE",
  CREATE_CAMPAIGN: "CREATE_CAMPAIGN",
  UPDATE_CAMPAIGN: "UPDATE_CAMPAIGN",
  CANCEL_PAYOUT: "CANCEL_PAYOUT",
  PROCESS_WITHDRAWAL: "PROCESS_WITHDRAWAL",
  UPDATE_PAYMENT_GATEWAY: "UPDATE_PAYMENT_GATEWAY",

  DASHBOARD_PAGE: "DASHBOARD_PAGE",
  VIEW_USER_PAGE: "VIEW_USER_PAGE",
  VIEW_USER_DETAILS_PAGE: "VIEW_USER_DETAILS_PAGE",
  SUBACCOUNT_PAGE: "SUBACCOUNT_PAGE",
  VIEW_TRANSACTION_PAGE: "VIEW_TRANSACTION_PAGE",
  PACKAGE_PAGE: "PACKAGE_PAGE",
  PRICING_PACKAGE_LABEL_PAGE: "PRICING_PACKAGE_LABEL_PAGE",
  CREATE_PRICING_PACKAGE_LABEL: "CREATE_PRICING_PACKAGE_LABEL",
  UPDATE_PRICING_PACKAGE_LABEL: "UPDATE_PRICING_PACKAGE_LABEL",
  SETTING_PAGE: "SETTING_PAGE",
  MARKETING_PAGE: "MARKETING_PAGE",
  FINANCE_PAGE: "FINANCE_PAGE",
  OPERATION_PAGE: "OPERATION_PAGE",
  FEATURES_TEST_PAGE: "FEATURES_TEST_PAGE",
  VIEW_ACCOUNT_MANAGER_PAGE: "VIEW_ACCOUNT_MANAGER_PAGE",
  QUESTIONAIRE_PAGE: "QUESTIONAIRE_PAGE",
  PAYOUT_UPLOAD: "PAYOUT_UPLOAD",
  PAYOUT_APPROVAL: "PAYOUT_APPROVAL",
  ADD_CREDIT: "ADD_CREDIT",
  EDIT_COD: "EDIT_COD",
  ASSIGN_ACCOUNT_MANAGER: "ASSIGN_ACCOUNT_MANAGER",
  MARK_CANCEL_ORDER: "MARK_CANCEL_ORDER",
  BULK_CANCEL: "BULK_CANCEL",
  BULK_REFUND: "BULK_REFUND",
  UPLOAD_PRICING: "UPLOAD_PRICING",
  BULK_REFUND_WEIGHT_DISPUTE: "BULK_REFUND_WEIGHT_DISPUTE",
  REFUND_WEIGHT_DISPUTE: "REFUND_WEIGHT_DISPUTE",
  UPDATE_CANCEL_REQUEST: "UPDATE_CANCEL_REQUEST",
  UPDATE_SETTING: "UPDATE_SETTING",
  DISCOUNT_CODE_PAGE: "DISCOUNT_CODE_PAGE",
  VOUCHER_PAGE: "VOUCHER_PAGE",
  CRUD_FLYERS_REQUEST: "CRUD_FLYERS_REQUEST",
  UPDATE_CREDIT_TAGGING: "UPDATE_CREDIT_TAGGING",
  ASSIGN_DHL_CUSTOM_CONFIG: "ASSIGN_DHL_CUSTOM_CONFIG",
  EDIT_PHONE_EMAIL: "EDIT_PHONE_EMAIL",
  CHARGE_CARD: "CHARGE_CARD",
  ADMIN_MANUAL_TRANSACTION: "ADMIN_MANUAL_TRANSACTION",
  UPDATE_BETA_FEATURES: "UPDATE_BETA_FEATURES",
  VIEW_PACKAGE: "VIEW_PACKAGE",
  ASSIGN_PACKAGE: "ASSIGN_PACKAGE",
  DOWNLOAD_CONNOTE: "DOWNLOAD_CONNOTE",
  REFUND_COD: "REFUND_COD",
  VIEW_CHANGE_LOG: "VIEW_CHANGE_LOG",
  SYNC_ORDER_STATUS: "SYNC_ORDER_STATUS",
  UPDATE_ORDER_STATUS: "UPDATE_ORDER_STATUS",
  BULK_SEARCH: "BULK_SEARCH",
  BULK_DOWNLOAD_CONNOTE: "BULK_DOWNLOAD_CONNOTE",
  VIEW_PRICING: "VIEW_PRICING",
  CREATE_DISCOUNT_CODE: "CREATE_DISCOUNT_CODE",
  UPDATE_DISCOUNT_CODE: "UPDATE_DISCOUNT_CODE",
  DELETE_DISCOUNT_CODE: "DELETE_DISCOUNT_CODE",
  CREATE_VOUCHER: "CREATE_VOUCHER",
  UPDATE_VOUCHER: "UPDATE_VOUCHER",
  DELETE_VOUCHER: "DELETE_VOUCHER",
  DISPATCH_VOUCHER: "DISPATCH_VOUCHER",
  VIEW_REFERRAL_PAGE: "VIEW_REFERRAL_PAGE",
  VIEW_ACCOUNT_MANAGER_DETAILS: "VIEW_ACCOUNT_MANAGER_DETAILS",
  UPDATE_REMITTANCE_STATUS: "UPDATE_REMITTANCE_STATUS",
  UPLOAD_CHECK_REMITTANCE: "UPLOAD_CHECK_REMITTANCE",
  BULK_UPDATE_WEIGHT_DISPUTE: "BULK_UPDATE_WEIGHT_DISPUTE",
  VIEW_PAYOUT_PAGE: "VIEW_PAYOUT_PAGE",
  VERIFY_EMAIL: "VERIFY_EMAIL",
  SYNC_BREVO: "SYNC_BREVO",
  VIEW_UNKNOWN_STATUS: "VIEW_UNKNOWN_STATUS",
  VIEW_ANALYSIS_PAGE: "VIEW_ANALYSIS_PAGE",
  UPDATE_INSURANCE_STATUS: "UPDATE_INSURANCE_STATUS",
  VIEW_INSURANCE_PAGE: "VIEW_INSURANCE_PAGE",
  UPDATE_MERCHANT: "UPDATE_MERCHANT",
  RECEIVER_ORDER_STATS: "RECEIVER_ORDER_STATS",
  VIEW_LOGS: "VIEW_LOGS",
  VIEW_WEIGHT_DISPUTE_PAGE: "VIEW_WEIGHT_DISPUTE_PAGE",
  VIEW_SYSTEM_PAGE: "VIEW_SYSTEM_PAGE",
  GENERATE_HTTP_LOGS: "GENERATE_HTTP_LOGS",
  GET_USER_PERM: "GET_USER_PERM",
  GET_INFO: "GET_INFO",
  UPDATE_PASSWORD: "UPDATE_PASSWORD",
  VIEW_REFEREE: "VIEW_REFEREE",
  CHANGE_CONNOTE_TYPE: "CHANGE_CONNOTE_TYPE",
  DASHBOARD_QUESTIONAIRE: "DASHBOARD_QUESTIONAIRE",
  UPDATE_PROFILE: "UPDATE_PROFILE",
  STATEMENT_PAGE: "STATEMENT_PAGE",
  ANNOUNCEMENT: "ANNOUNCEMENT",
  VERIFY_PHONE: "VERIFY_PHONE",
  EXPORT_LIST: "EXPORT_LIST",
  VIEW_POD: "VIEW_POD",
  UPLOAD_INVOICE: "UPLOAD_INVOICE",
  DISCOUNT_CODE_CHECK: "DISCOUNT_CODE_CHECK",
  GET_RTO_STAT: "GET_RTO_STAT",
  RIDER_INFO: "RIDER_INFO",
  WOOCOMMERCE: "WOOCOMMERCE",
  SHOPIFY: "SHOPIFY",
  BULK_ORDER_EXPORT: "BULK_ORDER_EXPORT",
  CRUD_ORDER: "CRUD_ORDER",
  CRUD_SHIPMENT: "CRUD_SHIPMENT",
  REMITTANCE: "REMITTANCE",
  PRICE_QUOTE: "PRICE_QUOTE",
  CART_PAGE: "CART_PAGE",
  GENERATE_PL9: "GENERATE_PL9",
  TOPUP_PACKAGE: "TOPUP_PACKAGE",
  REQUEST_FLYERS: "REQUEST_FLYERS",
  CREDITS: "CREDITS",
  GENERATE_TOKEN: "GENERATE_TOKEN",
  ADD_WEBHOOK: "ADD_WEBHOOK",
  VERIFY_POSTCODE: "VERIFY_POSTCODE",
  CRUD_ADDRESS: "CRUD_ADDRESS",
  CRUD_CARD: "CRUD_CARD",
  SAVE_CARD: "SAVE_CARD",
  CRUD_AWB_LOGO: "UPLOAD_AWB_LOGO",
  CRUD_SUBACCOUNT: "CRUD_SUBACCOUNT",
  VIEW_INVOICE: "VIEW_INVOICE",
  GET_SETTING: "GET_SETTING",
  INSURANCE: "INSURANCE",
  DOWNLOAD_PAYMENT_ADVICE: "DOWNLOAD_PAYMENT_ADVICE",
  FLYERS_REQUEST_PAGE: "FLYERS_REQUEST_PAGE",
  UPDATE_QUESTIONAIRE_STATUS: "UPDATE_QUESTIONAIRE_STATUS",
  EDIT_QUESTIONAIRE: "EDIT_QUESTIONAIRE",
  VIEW_ISSUES: "VIEW_ISSUES",
  CREATE_ISSUES: "CREATE_ISSUES",
  COMMENT_ISSUES: "COMMENT_ISSUES",
  ASSIGN_ISSUES: "ASSIGN_ISSUES",
  COD_RECONCILATION_CALENDER: "COD_RECONCILATION_CALENDER",
  NDR_ODRER_PAGE: "NDR_ODRER_PAGE",
  COD_ORDER_PAGE: "COD_ORDER_PAGE",
  RETURNED_ORDER_PAGE: "RETURNED_ORDER_PAGE",
  CANCEL_REQUEST_ORDER_PAGE: "CANCEL_REQUEST_ORDER_PAGE",
  DELETE_FLYERS_REQUEST: "DELETE_FLYERS_REQUEST",
  EXPORT_FLYERS_REQUEST: "EXPORT_FLYERS_REQUEST",
  EXPORT_TOPUP_REPORT: "EXPORT_TOPUP_REPORT",
  VIEW_USER_NOTES: "VIEW_USER_NOTES",
  ADD_USER_NOTES: "ADD_USER_NOTES",
  EDIT_USER_NOTES: "EDIT_USER_NOTES",
  VIEW_OTP: "VIEW_OTP",
  VIEW_CARGO_ACTIVATION: "VIEW_CARGO_ACTIVATION",
  VERIFY_CARGO_ACTIVATION: "VERIFY_CARGO_ACTIVATION",
  ADHOC_NOTIFICATION_PAGE: "ADHOC_NOTIFICATION_PAGE",
  NEWS_PAGE: "NEWS_PAGE",
  PNL_PAGE: "PNL_PAGE",
  BANNER_PAGE: "BANNER_PAGE",
  EXPORT_WEIGHT_DISPUTE_LIST: "EXPORT_WEIGHT_DISPUTE_LIST",
  EXPORT_TRANSACTION_WEIGHT_DISPUTE: "EXPORT_TRANSACTION_WEIGHT_DISPUTE",
  VIEW_USER_AUDIT: "VIEW_USER_AUDIT",
  VIEW_ADMIN_AUDIT_LOGS: "VIEW_ADMIN_AUDIT_LOGS",
  VIEW_EMAIL_LOGS: "VIEW_EMAIL_LOGS",
  // Mirrors constants/Permission.js in parceldaily-api. Granted to ACCESS_ADMIN only —
  // minting a credential is effectively granting data access.
  VIEW_API_CREDENTIALS: "VIEW_API_CREDENTIALS",
  MANAGE_API_CREDENTIALS: "MANAGE_API_CREDENTIALS",

  // newly added permissions
  VIEW_DASHBOARD_ANALYTICS: "VIEW_DASHBOARD_ANALYTICS",
  VIEW_GENERAL_ANALYTICS: "VIEW_GENERAL_ANALYTICS",
  VIEW_USAGE_ANALYTICS: "VIEW_USAGE_ANALYTICS",
  VIEW_ORDER_ANALYTICS: "VIEW_ORDER_ANALYTICS",
  VIEW_COD_ANALLYTICS: "VIEW_COD_ANALLYTICS",
  VIEW_NOTIFICATION_ANALYTICS: "VIEW_NOTIFICATION_ANALYTICS",
  EXPORT_USER_LIST: "EXPORT_USER_LIST",

  // Payout Permission
  UPDATE_BENEFICIARY_STATUS: "UPDATE_BENEFICIARY_STATUS",
  CLAIM_PAYOUT_PAGE: "CLAIM_PAYOUT_PAGE",
  VIEW_REFERRAL_COMMISSION: "VIEW_REFERRAL_COMMISSION",

  // Announcement Permissions
  VIEW_ANNOUCEMENT: "VIEW_ANNOUCEMENT",
  CREATE_ANNOUCEMENT: "CREATE_ANNOUCEMENT",
  UPDATE_ANNOUCEMENT: "UPDATE_ANNOUCEMENT",

  EXPORT_USER_ORDER: "EXPORT_USER_ORDER",

  // Mission Permissions
  MISSION_PAGE: "MISSION_PAGE",
  CREATE_MISSION: "CREATE_MISSION",
  UPDATE_MISSION: "UPDATE_MISSION",
  TOGGLE_MISSION_STATUS: "TOGGLE_MISSION_STATUS",
  DELETE_MISSION: "DELETE_MISSION",

  // Currency Conversion (reward base-earning rate)
  VIEW_CURRENCY_CONVERSION: "VIEW_CURRENCY_CONVERSION",
  CREATE_CURRENCY_CONVERSION: "CREATE_CURRENCY_CONVERSION",
  UPDATE_CURRENCY_CONVERSION: "UPDATE_CURRENCY_CONVERSION",
  TOGGLE_CURRENCY_CONVERSION_STATUS: "TOGGLE_CURRENCY_CONVERSION_STATUS",
  DELETE_CURRENCY_CONVERSION: "DELETE_CURRENCY_CONVERSION",

  // Welcome Package Control (new-user promo packages)
  VIEW_WELCOME_PACKAGE: "VIEW_WELCOME_PACKAGE",
  CREATE_WELCOME_PACKAGE: "CREATE_WELCOME_PACKAGE",
  UPDATE_WELCOME_PACKAGE: "UPDATE_WELCOME_PACKAGE",
  TOGGLE_WELCOME_PACKAGE_STATUS: "TOGGLE_WELCOME_PACKAGE_STATUS",

  // Redemption module
  VIEW_REWARD_CATALOG: "VIEW_REWARD_CATALOG",
  CREATE_REWARD_ITEM: "CREATE_REWARD_ITEM",
  UPDATE_REWARD_ITEM: "UPDATE_REWARD_ITEM",
  TOGGLE_REWARD_ITEM_STATUS: "TOGGLE_REWARD_ITEM_STATUS",
  DELETE_REWARD_ITEM: "DELETE_REWARD_ITEM",
  VIEW_REDEMPTION_SETTINGS: "VIEW_REDEMPTION_SETTINGS",
  UPDATE_REDEMPTION_SETTINGS: "UPDATE_REDEMPTION_SETTINGS",
  VIEW_REDEMPTION_PAGE: "VIEW_REDEMPTION_PAGE",
  EXPORT_REDEMPTION_LIST: "EXPORT_REDEMPTION_LIST",
  EXPORT_POINT_HISTORY_LIST: "EXPORT_POINT_HISTORY_LIST",
  CANCEL_REDEMPTION: "CANCEL_REDEMPTION",
  VIEW_REDEMPTION_REPORT: "VIEW_REDEMPTION_REPORT",

  // Beneficiary Request Permission
  VIEW_BENEFICIARY_REQUEST_PAGE: "VIEW_BENEFICIARY_REQUEST_PAGE",
  UPDATE_BENEFICIARY_REQUEST: "UPDATE_BENEFICIARY_REQUEST",
};

export const USER_ROLES = {
  USER: {
    id: "0",
    name: "User"
  },
  ADMIN: {
    id: "1",
    name: "Admin"
  }
}
